import {debounce} from 'lodash'
import {useCallback, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import CurrencyComp from '../../../../components/currencyComponent/CurrencyComp'
import DateComp from '../../../../components/dateComponent/DateComp'
import {LoadingComponent} from '../../../../components/loadingComponent/LoadingComponent'
import NoRecordFound from '../../../../components/noRecord/NoRecordFound'
import Pagination from '../../../../components/pagination/Pagination'
import SearchBarComponent from '../../../../components/searchBar/SearchBarComponent'
import TableHeading from '../../../../components/tableHeading/TableHeading'
import {constraintConfig} from '../../../../constraintConfig'
import {useGetAllBankFilesLineItemsQuery} from '../../../../services/AutomationApi'
import useColumnVisibility from '../../../customHooks/useColumnVisibility'
import labelKey from '../../../localization/label.json'
import TextField from '../../../../components/textFields/TextField'
import TableSettingMenu from '../../../../components/tableHeading/TableSettingMenu'
import {BiDotsVerticalRounded} from 'react-icons/bi'
import {Dropdown, DropdownButton} from 'react-bootstrap'
import {Tooltip} from 'react-tooltip'
import ReactReadMoreReadLess from 'react-read-more-read-less'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  bankFeedData?: any
  userBankFeedData?: any
}
const AutomationCCFeedsStatsEnhancements = ({bankFeedData, userBankFeedData}: Props) => {
  const {id} = useParams()

  const {hiddenColumns, handleToggleColumn} = useColumnVisibility({pageName: 'bankCCFeeds'})

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchStr, setSearchStr] = useState('') // debounce search
  const [immediateSearchStr, setImmediateSearchStr] = useState('')
  const [sortBy, setSortBy] = useState('itemImportDate')
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortedColumn, setSortedColumn] = useState('itemImportDate')
  const [filterByStatus, setFilterByStatus] = useState(true)
  const [activeTab, setActiveTab] = useState(true)
  const [isLoading, setIsLoading] = useState(false) // Track loading state

  // Debounced search state
  // const [searchStr, setSearchStr] = useState('');

  const {data, refetch} = useGetAllBankFilesLineItemsQuery({
    // accountNumber: userBankFeedData?.accountNumber,
    fileInfoId: bankFeedData?.fileInfoId,
    // fileInfoId: id,
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr,
    sortBy: sortBy,
    sortOrder: sortOrder,
    IslinkedItems: filterByStatus,
  })
  useEffect(() => {
    setIsLoading(true) // Set loading to true when filter changes
    refetch().finally(() => setIsLoading(false)) // Finally, set loading to false when refetch is done
  }, [filterByStatus, pageNumber, pageSize, refetch])

  const handlePageSizeChange = (e: any) => {
    const newSize = parseInt(e.target.value)
    setPageSize(newSize)
    setPageNumber(1) // Reset page number to 1
  }
  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1)
  }
  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1) // Reset the page to 1
  }
  const handleSort = (property: string) => {
    setSortBy(property)
    if (sortedColumn === property) {
      setSortOrder((prevSortOrder) => (prevSortOrder === 'asc' ? 'desc' : 'asc'))
    } else {
      setSortedColumn(property)
      setSortOrder('asc')
    }
  }

  const handleSearchChange = (e: any) => {
    const {value} = e.target
    setImmediateSearchStr(value) // Update immediate search state

    delayedSearch(value) // Update debounced search state
  }

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue)
    }, 500),
    []
  )

  useEffect(() => {
    if (searchStr !== '' && sortOrder !== '' && sortBy !== '') {
      // Trigger the API call after the debounce time
      refetch()
    }
  }, [searchStr, sortOrder, sortBy, refetch])
  // const [hiddenColumns, setHiddenColumns] = useState<string[]>(['cCTransactionID', 'lineItemDetailEntityId', 'bankVendorName', 'employeeId', 'itemImportDate', 'merchantType', 'itemDescription', 'transactionDate', 'productCode', 'ccTotalAmount', 'userFullName', 'expenseReportId', 'expenseCategoryName', 'vendorName', 'itemDate', 'itemAmount', 'currency', 'itemDebitOrCreditIndicator', 'debitOrCreditIndicator', 'accountNumber']);
  // const handleToggleColumn = (columnId: string) => {
  //     if (hiddenColumns.includes(columnId)) {
  //         setHiddenColumns(hiddenColumns.filter((id) => id !== columnId));
  //     } else {
  //         setHiddenColumns([...hiddenColumns, columnId]);
  //     }
  // };
  const handleTabChange = (status: boolean) => {
    setActiveTab(status)
    setFilterByStatus(status)
    setTimeout(() => {
      refetch()
    }, 200)
    setPageNumber(1)
    setPageSize(10)
  }
  return (
    <>
      <div className='card mb-5'>
        <div className='card-header border-0 pt-6'>
          <div className='d-flex align-items-center justify-content-between w-100'>
            <div className='btn-group overflow-auto' style={{minWidth: 'max-content'}}>
              <button
                type='button'
                className={`btn btn-sm ${activeTab === true ? 'btn-primary' : 'btn-light-primary'}`}
                onClick={() => handleTabChange(true)}
              >
                {labelKey.lineItems}
              </button>
              <button
                type='button'
                className={`btn btn-sm ${
                  activeTab === false ? 'btn-primary' : 'btn-light-primary'
                }`}
                onClick={() => handleTabChange(false)}
              >
                {labelKey.lineItemsPending}
              </button>
            </div>
            <SearchBarComponent
              placeholder='User Name'
              value={immediateSearchStr}
              onChange={handleSearchChange} // Use immediate search handler
            />
          </div>
        </div>
        <div className='card-body py-8'>
          <div className='col-md-12'>
            <div className='table-responsive pe-5' style={{height: '63vh'}}>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <>
                      {hiddenColumns.includes('cCTransactionID') && (
                        <TableHeading
                          label={labelKey.cCTransactionID}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='cCTransactionID'
                          className='ps-4'
                        />
                      )}

                      {hiddenColumns.includes('accountNumber') && (
                        <TableHeading
                          label={labelKey.accountNumber}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='accountNumber'
                          className='ps-4'
                        />
                      )}
                      {hiddenColumns.includes('merchantType') && (
                        <TableHeading
                          label={labelKey.merchantType}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='merchantType'
                          className='ps-4'
                        />
                      )}
                      {/* {hiddenColumns.includes('productCode') && (
                                                <TableHeading
                                                    label={labelKey.productCode}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='productCode'
                                                />
                                            )} */}
                      {hiddenColumns.includes('itemDescription') && (
                        <TableHeading
                          label={labelKey.itemDescription}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='itemDescription'
                        />
                      )}
                      {hiddenColumns.includes('itemImportDate') && (
                        <TableHeading
                          label={labelKey.itemImportDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='itemImportDate'
                          className='w-100px text-end pe-15'
                        />
                      )}
                      {hiddenColumns.includes('transactionDate') && (
                        <TableHeading
                          label={labelKey.transactionDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='transactionDate'
                          className='w-100px text-end'
                        />
                      )}
                      {hiddenColumns.includes('bankVendorName') && (
                        <TableHeading
                          label={labelKey.vendor}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='bankVendorName'
                        />
                      )}
                      {hiddenColumns.includes('debitOrCreditIndicator') && (
                        <TableHeading
                          label={labelKey.indicator}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='debitOrCreditIndicator'
                          className='w-100px text-end'
                        />
                      )}
                      {hiddenColumns.includes('ccTotalAmount') && (
                        <TableHeading
                          label={labelKey.ccTotalAmount}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='ccTotalAmount pe-4'
                          labelClassName='justify-content-end'
                        />
                      )}
                      {activeTab != true && (
                        <>
                          {hiddenColumns.includes('userAccountId') && (
                            <TableHeading
                              label={labelKey.orgUserID}
                              sortedColumn={sortedColumn}
                              sortOrder={sortOrder}
                              handleSort={handleSort}
                              columnId='userAccountId'
                              labelClassName='justify-content-end'
                            />
                          )}
                        </>
                      )}
                      {hiddenColumns.includes('employeeId') && (
                        <TableHeading
                          label={labelKey.employeeId}
                          columnId='employeeId'
                          className='ps-4'
                          labelClassName='text-primary'
                        />
                      )}
                      {hiddenColumns.includes('bcEmployeeId') && (
                        <TableHeading
                          label={labelKey.bcEmployeeId}
                          columnId='bcEmployeeId'
                          className='ps-4'
                          labelClassName='text-primary'
                        />
                      )}
                      {hiddenColumns.includes('userFullName') && (
                        <TableHeading
                          label={labelKey.userName}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='userFullName'
                          labelClassName='text-primary'
                        />
                      )}
                    </>
                    {activeTab === true && (
                      <>
                        {/* {hiddenColumns.includes('lineItemDetailEntityId') && (
                                                    <TableHeading
                                                        label={labelKey.lineItemDetailEntityId}
                                                        sortedColumn={sortedColumn}
                                                        sortOrder={sortOrder}
                                                        handleSort={handleSort}
                                                        columnId='lineItemDetailEntityId'
                                                        className="ps-4"
                                                        labelClassName="text-primary"
                                                    />
                                                )} */}

                        {hiddenColumns.includes('expenseReportId') && (
                          <TableHeading
                            label={labelKey.reportId}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='expenseReportId'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('ssLineItemId') && (
                          <TableHeading
                            label={labelKey.ssLineItemId}
                            columnId='ssLineItemId'
                            className='ps-4'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('expenseCategoryName') && (
                          <TableHeading
                            label={labelKey.category}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='expenseCategoryName'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('vendorName') && (
                          <TableHeading
                            label={labelKey.vendor}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='vendorName'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('expensePaymentMethod') && (
                          <TableHeading
                            label={labelKey.paymentMethod}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='expensePaymentMethod'
                            labelClassName='text-primary text-center'
                          />
                        )}
                        {hiddenColumns.includes('itemDate') && (
                          <TableHeading
                            label={labelKey.itemDate}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='itemDate'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('itemAmount') && (
                          <TableHeading
                            label={labelKey.itemAmount}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='itemAmount'
                            className='pe-4'
                            labelClassName='justify-content-end text-primary'
                          />
                        )}
                        {hiddenColumns.includes('ccItemDescription') && (
                          <TableHeading
                            label={labelKey.ccItemDescription}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='ccItemDescription'
                            className='pe-4'
                            labelClassName='text-primary text-center'
                          />
                        )}
                        {hiddenColumns.includes('currency') && (
                          <TableHeading
                            label={labelKey.currency}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='currency'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('itemDebitOrCreditIndicator') && (
                          <TableHeading
                            label={labelKey.indicator}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='itemDebitOrCreditIndicator'
                            labelClassName='text-primary'
                          />
                        )}
                        {hiddenColumns.includes('recordSourceId') && (
                          <TableHeading
                            label={labelKey.source}
                            columnId='recordSourceId'
                            labelClassName='text-primary text-center'
                          />
                        )}
                        {hiddenColumns.includes('internalNotes') && (
                          <TableHeading
                            label={labelKey.internalNotes}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='internalNotes'
                            labelClassName='text-primary text-center'
                          />
                        )}
                        {hiddenColumns.includes('createdDate') && (
                          <TableHeading
                            label={labelKey.createdDate}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='createdDate'
                            labelClassName='text-primary text-center'
                          />
                        )}
                        {hiddenColumns.includes('updatedDate') && (
                          <TableHeading
                            label={labelKey.updatedDate}
                            sortedColumn={sortedColumn}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            columnId='updatedDate'
                            labelClassName='text-primary text-center'
                          />
                        )}
                      </>
                    )}

                    <th className='text-end rounded-end pe-2'>
                      <Tooltip id='setting-menu' place='top' />

                      <DropdownButton
                        id='dropdown-basic-button'
                        autoClose='outside'
                        className='bankCC-table-menu'
                        variant='transparent'
                        title={
                          <BiDotsVerticalRounded
                            // style={{ color: "#000" }}
                            data-tooltip-id='setting-menu'
                            data-tooltip-content='Display Menu'
                          />
                        }
                      >
                        <div className='w-300px w-md-325px'>
                          <div className='px-7 py-5'>
                            <div className='fs-5 text-dark fw-bold'>Display Menu</div>
                          </div>

                          <div className='separator border-gray-200'></div>

                          <div className='px-7 py-5' data-kt-user-table-filter='form'>
                            <div className='overflow-auto sm-scroll mh-350px'>
                              <>
                                <TextField
                                  rightLabel={labelKey.cCTransactionID}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('cCTransactionID')}
                                  checked={hiddenColumns.includes('cCTransactionID')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.accountNumber}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('accountNumber')}
                                  checked={hiddenColumns.includes('accountNumber')}
                                  fieldClass='mb-4'
                                />

                                <TextField
                                  rightLabel={labelKey.merchantType}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('merchantType')}
                                  checked={hiddenColumns.includes('merchantType')}
                                  fieldClass='mb-4'
                                />

                                {/* <TextField
                                                                    rightLabel={labelKey.productCode}
                                                                    type="checkbox"
                                                                    onChange={() => handleToggleColumn("productCode")}
                                                                    checked={hiddenColumns.includes('productCode')}
                                                                    fieldClass='mb-4'
                                                                /> */}
                                <TextField
                                  rightLabel={labelKey.itemDescription}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('itemDescription')}
                                  checked={hiddenColumns.includes('itemDescription')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.itemImportDate}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('itemImportDate')}
                                  checked={hiddenColumns.includes('itemImportDate')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.transactionDate}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('transactionDate')}
                                  checked={hiddenColumns.includes('transactionDate')}
                                  fieldClass='mb-4'
                                />

                                <TextField
                                  rightLabel={labelKey.vendor}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('bankVendorName')}
                                  checked={hiddenColumns.includes('bankVendorName')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.indicator}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('debitOrCreditIndicator')}
                                  checked={hiddenColumns.includes('debitOrCreditIndicator')}
                                  fieldClass='mb-4'
                                />

                                <TextField
                                  rightLabel={labelKey.ccTotalAmount}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('ccTotalAmount')}
                                  checked={hiddenColumns.includes('ccTotalAmount')}
                                  fieldClass='mb-4'
                                />
                                {activeTab !== true && (
                                  <>
                                    <TextField
                                      rightLabel={labelKey.orgUserID}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('userAccountId')}
                                      checked={hiddenColumns.includes('userAccountId')}
                                      fieldClass='mb-4'
                                    />
                                  </>
                                )}
                                <TextField
                                  rightLabel={labelKey.employeeId}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('employeeId')}
                                  checked={hiddenColumns.includes('employeeId')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.bcEmployeeId}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('bcEmployeeId')}
                                  checked={hiddenColumns.includes('bcEmployeeId')}
                                  fieldClass='mb-4'
                                />
                                <TextField
                                  rightLabel={labelKey.userName}
                                  type='checkbox'
                                  onChange={() => handleToggleColumn('userFullName')}
                                  checked={hiddenColumns.includes('userFullName')}
                                  fieldClass='mb-4'
                                />
                                {activeTab === true && (
                                  <>
                                    <TextField
                                      rightLabel={labelKey.reportId}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('expenseReportId')}
                                      checked={hiddenColumns.includes('expenseReportId')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.ssLineItemId}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('ssLineItemId')}
                                      checked={hiddenColumns.includes('ssLineItemId')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.category}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('expenseCategoryName')}
                                      checked={hiddenColumns.includes('expenseCategoryName')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.vendor}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('vendorName')}
                                      checked={hiddenColumns.includes('vendorName')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.paymentMethod}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('expensePaymentMethod')}
                                      checked={hiddenColumns.includes('expensePaymentMethod')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.itemDate}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('itemDate')}
                                      checked={hiddenColumns.includes('itemDate')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.itemAmount}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('itemAmount')}
                                      checked={hiddenColumns.includes('itemAmount')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.ccItemDescription}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('ccItemDescription')}
                                      checked={hiddenColumns.includes('ccItemDescription')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.currency}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('currency')}
                                      checked={hiddenColumns.includes('currency')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.indicator}
                                      type='checkbox'
                                      onChange={() =>
                                        handleToggleColumn('itemDebitOrCreditIndicator')
                                      }
                                      checked={hiddenColumns.includes('itemDebitOrCreditIndicator')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.source}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('recordSourceId')}
                                      checked={hiddenColumns.includes('recordSourceId')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.internalNotes}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('internalNotes')}
                                      checked={hiddenColumns.includes('internalNotes')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.createdDate}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('createdDate')}
                                      checked={hiddenColumns.includes('createdDate')}
                                      fieldClass='mb-4'
                                    />
                                    <TextField
                                      rightLabel={labelKey.updatedDate}
                                      type='checkbox'
                                      onChange={() => handleToggleColumn('updatedDate')}
                                      checked={hiddenColumns.includes('updatedDate')}
                                      fieldClass='mb-4'
                                    />
                                  </>
                                )}
                              </>
                            </div>
                          </div>
                        </div>
                      </DropdownButton>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && (
                    <>
                      {data?.result?.data?.length > 0 ? (
                        <>
                          {data?.result?.data?.map((data: any, index: any) => (
                            <tr key={index}>
                              {hiddenColumns.includes('cCTransactionID') && (
                                <td className='ps-4'>
                                  {data?.processorTransactionId
                                    ? data?.processorTransactionId
                                    : 'N/A'}
                                </td>
                              )}
                              {hiddenColumns.includes('accountNumber') && (
                                <td>{data?.accountNumber ? data?.accountNumber : 'N/A'}</td>
                              )}
                              {hiddenColumns.includes('merchantType') && (
                                <td>{data?.merchantType ? data?.merchantType : 'N/A'}</td>
                              )}
                              {/* {hiddenColumns.includes('productCode') && (
                                                                <td>
                                                                    {data?.productCode}
                                                                </td>
                                                            )} */}
                              {hiddenColumns.includes('itemDescription') && (
                                <td>
                                  <div className='w-200px text-wrap'>
                                    {data?.itemDescription ? data?.itemDescription : 'N/A'}
                                  </div>
                                </td>
                              )}
                              {hiddenColumns.includes('itemImportDate') && (
                                <td className='text-end pe-15'>
                                  <DateComp formattedDate={data?.itemImportDate} />{' '}
                                </td>
                              )}
                              {hiddenColumns.includes('transactionDate') && (
                                <td className='text-end'>
                                  <DateComp formattedDate={data?.transactionDate} />
                                </td>
                              )}
                              {hiddenColumns.includes('bankVendorName') && (
                                <td>{data?.bankVendorName}</td>
                              )}
                              {hiddenColumns.includes('debitOrCreditIndicator') && (
                                <td
                                  className={`text-center ${
                                    data?.debitOrCreditIndicator ===
                                    constraintConfig.debitOrCreditIndicator.creditIndicator
                                      ? 'text-danger'
                                      : null
                                  }`}
                                >
                                  {data?.debitOrCreditIndicator}
                                </td>
                              )}
                              {hiddenColumns.includes('ccTotalAmount') && (
                                <td
                                  className={`text-end pe-4 ${
                                    data?.debitOrCreditIndicator ===
                                    constraintConfig.debitOrCreditIndicator.creditIndicator
                                      ? 'text-danger'
                                      : null
                                  }`}
                                >
                                  <CurrencyComp amount={data?.ccTotalAmount} />
                                </td>
                              )}
                              {activeTab !== true && (
                                <>
                                  {hiddenColumns.includes('userAccountId') && (
                                    <td className='ps-4 text-center'>
                                      {data?.userAccountId > 0 ? data?.userAccountId : ''}
                                    </td>
                                  )}
                                </>
                              )}
                              {hiddenColumns.includes('employeeId') && (
                                <td className='ps-4 text-center'>{data?.employeeId}</td>
                              )}
                              {hiddenColumns.includes('bcEmployeeId') && (
                                <td className='ps-4 text-center'>{data?.bcEmployeeId}</td>
                              )}
                              {hiddenColumns.includes('userFullName') && (
                                <td className='ps-4 text-center'>{data?.userFullName}</td>
                              )}
                              {activeTab === true && (
                                <>
                                  {hiddenColumns.includes('expenseReportId') && (
                                    <td>{data?.expenseReportId}</td>
                                  )}
                                  {hiddenColumns.includes('ssLineItemId') && (
                                    <td className='ps-4'>{data?.ccLineItemId}</td>
                                  )}
                                  {hiddenColumns.includes('expenseCategoryName') && (
                                    <td>{data?.expenseCategory?.title}</td>
                                  )}
                                  {hiddenColumns.includes('vendorName') && (
                                    <td>{data?.vendor?.name}</td>
                                  )}
                                  {hiddenColumns.includes('expensePaymentMethod') && (
                                    <td className='ps-4 text-center'>
                                      {data?.expensePaymentMethod?.title}
                                    </td>
                                  )}
                                  {hiddenColumns.includes('itemDate') && (
                                    <td className='text-center'>
                                      <DateComp formattedDate={data?.itemDate} />
                                    </td>
                                  )}
                                  {hiddenColumns.includes('itemAmount') && (
                                    <td
                                      className={`text-end   ${
                                        data?.debitOrCreditIndicator ===
                                        constraintConfig.debitOrCreditIndicator.creditIndicator
                                          ? 'text-danger'
                                          : null
                                      }`}
                                    >
                                      <CurrencyComp amount={data?.itemAmount} />
                                    </td>
                                  )}
                                  {hiddenColumns.includes('ccItemDescription') && (
                                    <td className='text-center'>{data?.ccItemDescription}</td>
                                  )}
                                  {hiddenColumns.includes('currency') && (
                                    <td className='text-center'>{data?.currency?.title}</td>
                                  )}
                                  {hiddenColumns.includes('itemDebitOrCreditIndicator') && (
                                    <td
                                      className={`text-center ${
                                        data?.debitOrCreditIndicator ===
                                        constraintConfig.debitOrCreditIndicator.creditIndicator
                                          ? 'text-danger'
                                          : null
                                      }`}
                                    >
                                      {data?.itemDebitOrCreditIndicator}
                                    </td>
                                  )}
                                  {hiddenColumns.includes('recordSourceId') && (
                                    <td className={`text-center `}>
                                      {data?.recordSourceId ===
                                      constraintConfig.recordSourceId.WebApp ? (
                                        <KTSVG
                                          path='/media/icons/figmaIcons/Web.svg'
                                          className='svg-icon-1 ms-4'
                                          svgClassName='w-20px h-20px'
                                          data-tooltip-id='web-source'
                                          data-tooltip-content='Website'
                                        />
                                      ) : data?.recordSourceId ===
                                        constraintConfig.recordSourceId.Mobile ? (
                                        <KTSVG
                                          path='/media/icons/figmaIcons/Mobile.svg'
                                          className='svg-icon-1 ms-4'
                                          data-tooltip-id='mobile-source'
                                          data-tooltip-content='Mobile'
                                        />
                                      ) : data?.recordSourceId ===
                                        constraintConfig.recordSourceId.BankFeed ? (
                                        <KTSVG
                                          path='/media/icons/figmaIcons/Bank.svg'
                                          className='svg-icon-1 ms-4'
                                          data-tooltip-id='bank-source'
                                          data-tooltip-content='Bank'
                                        />
                                      ) : data?.recordSourceId ===
                                        constraintConfig.recordSourceId.GorillaExpense ? (
                                        <KTSVG
                                          path='/media/icons/figmaIcons/Gorilla.svg'
                                          className='svg-icon-1 ms-4'
                                          data-tooltip-id='gorilla-source'
                                          data-tooltip-content='Gorilla Expense'
                                        />
                                      ) : null}
                                    </td>
                                  )}
                                  {hiddenColumns.includes('internalNotes') && (
                                    <td className='text-wrap w-400px'>
                                      {data && data.internalNotes && (
                                        <ReactReadMoreReadLess
                                          charLimit={35}
                                          readMoreText={'Read more'}
                                          readLessText={'Read less'}
                                          readMoreClassName='readMore'
                                          readLessClassName='readLess'
                                        >
                                          {data.internalNotes}
                                        </ReactReadMoreReadLess>
                                      )}
                                    </td>
                                  )}
                                  {hiddenColumns.includes('createdDate') && (
                                    <td className={`text-center `}>
                                      {' '}
                                      <DateComp formattedDate={data?.createdDate} />
                                    </td>
                                  )}
                                  {hiddenColumns.includes('updatedDate') && (
                                    <td className={`text-center `}>
                                      <DateComp formattedDate={data?.updatedDate} />
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={20}>
                            <NoRecordFound />
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                  {isLoading && (
                    <tr>
                      <td colSpan={20} className='text-center'>
                        <LoadingComponent />
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            <Pagination
              totalResult={
                data?.result?.totalRecords === 0
                  ? 0
                  : (data?.result?.pageNumber - 1) * data?.result?.pageSize + 1
              }
              toResult={
                data?.result?.totalRecords === 0
                  ? 0
                  : Math.min(
                      data?.result?.pageNumber * data?.result?.pageSize,
                      data?.result?.totalRecords
                    )
              }
              ofResult={data?.result?.totalRecords}
              onChange={handlePageSizeChange}
              pageSize={pageSize}
              onPageChange={handlePageClick}
              pageCount={data?.result?.totalPages || 0}
              currentPage={pageNumber}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default AutomationCCFeedsStatsEnhancements
